import React from 'react';
import { Plus, Wallet, X } from 'lucide-react';

// Extracted from EmployerDashboard.js — receives everything it needs via `ctx`.
export default function EmployerTopUpModal({ ctx }) {
  const { handleTopUp, setShowTopUp, setTopUpAmount, showTopUp, topUpAmount } = ctx;
  return (
    <>
    {showTopUp && (
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl w-full max-w-md shadow-2xl overflow-hidden">
          <div className="bg-gradient-to-r from-emerald-600 to-teal-600 px-6 py-4">
            <div className="flex items-center justify-between">
              <h3 className="text-xl font-bold text-white">Top Up Wallet</h3>
              <button
                onClick={() => {
                  setShowTopUp(false);
                  setTopUpAmount('');
                }}
                className="p-2 hover:bg-white/20 rounded-full transition"
              >
                <X className="w-5 h-5 text-white" />
              </button>
            </div>
          </div>
          <div className="p-6">
            <div className="mb-6">
              <label className="block text-sm font-medium text-slate-700 mb-2">
                Amount ($)
              </label>
              <input
                type="number"
                value={topUpAmount}
                onChange={(e) => setTopUpAmount(e.target.value)}
                placeholder="e.g., 500"
                className="w-full px-4 py-3 border border-slate-300 rounded-xl focus:ring-2 focus:ring-emerald-500 focus:border-emerald-500 text-lg"
                min="1"
                step="0.01"
                data-testid="topup-amount-input"
              />
            </div>
            
            {/* Quick Amount Buttons */}
            <div className="mb-6">
              <p className="text-sm text-slate-500 mb-3">Quick amounts:</p>
              <div className="grid grid-cols-4 gap-2">
                {[100, 250, 500, 1000].map((amount) => (
                  <button
                    key={amount}
                    onClick={() => setTopUpAmount(amount.toString())}
                    className={`py-2.5 rounded-xl font-semibold transition ${
                      topUpAmount === amount.toString()
                        ? 'bg-emerald-100 text-emerald-700 border-2 border-emerald-500'
                        : 'bg-slate-100 text-slate-700 hover:bg-slate-200'
                    }`}
                    data-testid={`quick-amount-${amount}`}
                  >
                    ${amount}
                  </button>
                ))}
              </div>
            </div>
            
            {/* Action Buttons */}
            <div className="flex gap-3">
              <button
                onClick={() => {
                  setShowTopUp(false);
                  setTopUpAmount('');
                }}
                className="flex-1 px-4 py-3 border border-slate-300 text-slate-700 rounded-xl font-semibold hover:bg-slate-50 transition"
              >
                Cancel
              </button>
              <button
                onClick={handleTopUp}
                disabled={!topUpAmount || parseFloat(topUpAmount) <= 0}
                className="flex-1 px-4 py-3 bg-emerald-600 text-white rounded-xl font-semibold hover:bg-emerald-700 transition disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                data-testid="add-funds-btn"
              >
                <Plus className="w-5 h-5" />
                Add Funds
              </button>
            </div>
          </div>
        </div>
      </div>
    )}
    </>
  );
}
